export default __webpack_public_path__ + "static/task_posted-9ecd8cfa825d8ddd6b7416a71d1cfff2.png";